import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  signal,
} from "@angular/core";
import moment from "moment";
import { LineChartComponent } from "src/app/components/line-chart/line-chart.component";

@Component({
  selector: "app-return-charts",
  templateUrl: "./return-charts.component.html",
  styleUrls: ["./return-charts.component.scss"],
  imports: [LineChartComponent],
  standalone: true,
})
export class ReturnChartsComponent implements OnInit, OnChanges {
  @Input() plotData: any = {};
  @Input() volatilityData: any = {};
  @Input() drawdownData: any[] = null;
  @Input() benchmark: any = null;
  @Input() benchmarks: any[] = [];
  @Input() subHeader: string = "";
  @Input() isPrint = false;
  @Input() startDate = null;
  @Input() endDate = null;
  @Output() afterDrawdownSetExtremes: EventEmitter<any> =
    new EventEmitter<any>();

  loaded = signal(false);
  series = [];

  drawDownExtraOptions = {
    yAxis: {
      opposite: false,
      minorTickInterval: 0.01,
      gridLineColor: "var(--border)",
      labels: {
        format: "{value}%",
      },
      title: {
        text: "Drawdown",
        style: {
          textTransform: "capitalize",
        },
      },
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        tooltip: {
          pointFormat: "{series.name}: <b>{point.y}%</b>",
        },
        dataGrouping: {
          enabled: false,
        },
      },
    },
  };
  volatilitsOptions = {
    ...this.drawDownExtraOptions,
    yAxis: {
      opposite: false,
      minorTickInterval: 0.01,
      labels: {
        format: "{value}%",
      },
      title: {
        text: "Volatility",
        style: {
          textTransform: "capitalize",
        },
      },
    },
  };

  constructor() {}

  ngOnInit(): void {
    this.initPlot();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.drawdownData) {
      this.loaded.set(false);
      this.initPlot();
    }
    if (changes.benchmarks) {
      this.loaded.set(false);
      this.initPlot();
    }
    if (changes.benchmark) {
      this.loaded.set(false);
      this.initPlot();
    }
  }

  initPlot() {
    this.series = [];

    const resp = this.plotData;

    // const drawdownData = resp.drawdown ? this.extractPlotData(resp.drawdown) : [];
    const drawdownData = this.drawdownData
      ? [
          {
            name: "Portfolio",
            data: this.drawdownData,
            type: "line",
          },
        ]
      : [];

    this.series.push({
      title: "",
      series: JSON.parse(JSON.stringify(this.volatilityData.series)),
    });
    this.series.push({
      title: "",
      series: drawdownData,
    });

    if (this.benchmark) {
      const drawdownStart = drawdownData[0].data[0][0];
      const volatilityStart = this.volatilityData.series[0].data[0][0];
      this.series[0].series.push(
        this.extractBenchmarkData(
          this.benchmark.rolling_std_deviation,
          this.benchmark.index_name_short,
          volatilityStart,
        ),
      );
      this.series[1].series.push(
        this.extractBenchmarkData(
          this.benchmark.drawdown,
          this.benchmark.index_name_short,
          drawdownStart,
        ),
      );
    }
    setTimeout(() => {
      this.loaded.set(true);
    }, 100);
  }

  extractBenchmarkData(list, name, start) {
    // convert string dates to timestamps and value tuples
    const convertedList = [];
    list.map((data: any[]) => {
      const date = data[0];
      if (date >= start) {
        convertedList.push([date, data[1]]);
      }
    });
    return {
      name: name,
      data: convertedList,
      type: "line",
    };
  }

  extractPlotData(list) {
    let result = [];
    Object.entries(list).map(([name, data]: [string, any]) => {
      let series = {
        name: name,
        data: data.map((d) => {
          if (d[1]) {
            d[1] = +d[1].toFixed(2);
          }
          return d;
        }),
        type: "line",
      };
      result.push(series);
    });
    return result;
  }

  onDrawdownDateChange(event) {
    this.afterDrawdownSetExtremes.emit(event);
  }
}
